import { render } from "./UserPreviewActions.vue?vue&type=template&id=3b064572&scoped=true"
import script from "./UserPreviewActions.vue?vue&type=script&lang=js"
export * from "./UserPreviewActions.vue?vue&type=script&lang=js"

import "./UserPreviewActions.vue?vue&type=style&index=0&id=3b064572&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b064572"]])

export default __exports__